module.exports = __webpack_public_path__ + "img/staking-banner.69f200b8.png";